import { lazyLoad } from 'utils/lazy';

export default lazyLoad(
  () => import('./ReportContainer'),
  (m) => m.Report
);

export const TestReport = lazyLoad(
  () => import('./ReportTestContainer'),
  (m) => m.Report
);

export * from './utils';
